<template>
  <div class="metersphere_testplan_bind_warp">
    <el-input min-width="2000px" v-if="(status === 2  ||  !cache_testplan_id)" v-model.trim="testplan_id" autocomplete="off" />
    <a class="testplan_style" v-else :href="testplan_url + testplan_id" target="__blank">{{ testplan_id
    }}</a>
   <el-button type="primary" v-if="status !== 2  &&  cache_testplan_id"  @click="(status = 2)">编辑</el-button>
    <el-button type="primary" v-else :loading="loading" @click="handleSure">确定</el-button>
<!--    <el-button type="primary" v-if="(status === 1)"  @click="handleCancel">取消</el-button>-->
  </div>
</template>
<script>
import {
  getDevOpsSpaceTestTaskApi,
  postDevopsSpaceStageActionApi,
} from "@/server/tops/devOps";
export default {
  props: {
    taskInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    getPlanId: {
      type: Function,
      default: function () {
        return () => { }
      }
    }
  },

  data() {
    return {
      testplan_id: '', // 地址参数
      cache_testplan_id : '', // 缓存地址参数
      testplan_url: '', // 基础地址
      loading: false,
      status: 1, // 0 编辑 1 确定
    };
  },
  async mounted() {
    await this.queryMetersphereTestplanBindInfo()
  },
  methods: {
    // 测试计划获取
    async queryMetersphereTestplanBindInfo() {
      try {
        const ret = await getDevOpsSpaceTestTaskApi({
       /*   action: 'metersphere_testplan_bind',
          testplan_env: this.taskInfo.env,
          testplan_type: 'get',*/
          taskId: this.taskInfo.id,
        })
        const  info = ret.data[0] ? ret.data[0]:{};
        this.testplan_id = info.meterspherePlanId;
        this.cache_testplan_id = info.meterspherePlanId;
        this.getPlanId(this.cache_testplan_id);
        this.testplan_url = info.metersphereUrl.split('?id=')[0] + '?id=';
      } catch (error) {
        console.log(error)
      }
    },
    // 测试计划更新
    async queryMetersphereTestplanBindUpdate() {
      try {
        this.loading = true;
        const ret = await postDevopsSpaceStageActionApi({
          action: 'metersphere_testplan_bind',
          testplan_env: this.taskInfo.env,
          testplan_type: 'update',
          task_id: this.taskInfo.id,
          testplan_id: this.testplan_id,
        })
        const success = ret.status === 'success';
        this.$notify({
          message: success ? '更新成功' : (ret.message || '更新失败'),
          type: success ? "success" : 'error',
        })
        if(success){
          this.cache_testplan_id = this.testplan_id;
          this.getPlanId(this.cache_testplan_id);
        }else{
          this.testplan_id = this.cache_testplan_id;
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false;
        this.status = 1;
      }
    },
    // 确定点击事件
    handleSure() {
      this.queryMetersphereTestplanBindUpdate()
    },
    // 取消点击事件
    handleCancel(){
      this.status = 0;
      this.testplan_id = this.cache_testplan_id;
    }
  },
};
</script>
<style lang="scss">
.metersphere_testplan_bind_warp {
  display: flex;

  .el-input__inner {
    width: 260px;
    margin-right: 5px;
  }

  .testplan_style {
    white-space: nowrap;
    font-size: 12px;
    margin-right: 10px;
    color: #409EFF;
    width: 250px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    line-height: 29px;
  }
}
</style>
